import React, { forwardRef } from 'react';
import InternalNotesThread, { InternalNotesThreadHandle } from './InternalNotesThread';

// Internal notes for one payment, backed by `payment_comments` (migration 0083).
// The thread itself lives in InternalNotesThread, which the B2B order detail
// page reuses against `order_comments`.

export type PaymentInternalNotesHandle = InternalNotesThreadHandle;

interface PaymentInternalNotesProps {
  paymentId: number | string | null | undefined;
  onRefresh?: () => void;
}

const PaymentInternalNotes = forwardRef<PaymentInternalNotesHandle, PaymentInternalNotesProps>(
  ({ paymentId, onRefresh }, ref) => (
    <InternalNotesThread
      ref={ref}
      entityId={paymentId}
      apiBase={`/api/accounting/payments/${paymentId}`}
      emptyHint="Add internal notes to track this payment and communicate with your team."
      onRefresh={onRefresh}
    />
  )
);

PaymentInternalNotes.displayName = 'PaymentInternalNotes';

export default PaymentInternalNotes;
